import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Dropdown, DropdownButton, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateItem } from '../../../actions/relationActions';
import { hideModal } from '../../../actions/modalsActions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getImageUrl } from '../../../configs/configs';
import { getSubCategoryOptions, getIndustryOptions, technologyOptions, malwareOptions } from '../../../configs/dropdownOptions';
//imported comps
import ImageUpload from '../../ImageUpload';
import TechnologySelect from './TechnologySelect';
import MalwareSelect from './MalwareSelect';
import ActorSelect from './ActorSelect';

let AdminForm = (props) => {
    const inputEl = useRef(null);
    const [mainCategory, setMainCategory] = useState(props.initialValues.mainCategory || '');
    const [url1, setUrl1] = useState(props.initialValues.url1 || '');
    const [url2, setUrl2] = useState(props.initialValues.url2 || '');
    const [url3, setUrl3] = useState(props.initialValues.url3 || '');
    const [url4, setUrl4] = useState(props.initialValues.url4 || '');
    const [url5, setUrl5] = useState(props.initialValues.url5 || '');
    const [title, setTitle] = useState(props.initialValues.title || '');
    const [detailedDescription, setDetailedDescription] = useState(props.initialValues.detailedDescription || '');
    const [subCategory, setSubCategory] = useState(props.initialValues.subCategory || []);
    const [industry, setIndustry] = useState(props.initialValues.industry || []);
    const [image, setImage] = useState(getImageUrl(props.initialValues.image) || '');
    const [BAMImage, setBAMImage] = useState(getImageUrl(props.initialValues.BAMImage) || '');
    const [tileTop, setTileTop] = useState(props.initialValues.tileTop || '');
    const [searchTags, setSearchTags] = useState(props.initialValues.searchTags || []);
    const [mainCategoryType, setMainCategoryType] = useState(props.initialValues.mainCategoryType || '');
    const [newTag1, setNewTag1] = useState(props.initialValues.newTag1 || '');
    const [newTag2, setNewTag2] = useState(props.initialValues.newTag2 || '');
    const [newTag3, setNewTag3] = useState(props.initialValues.newTag3 || '');
    const [newTag4, setNewTag4] = useState(props.initialValues.newTag4 || '');
    const [newTag5, setNewTag5] = useState(props.initialValues.newTag5 || '');
    const [newTag6, setNewTag6] = useState(props.initialValues.newTag6 || '');
    const [newTag7, setNewTag7] = useState(props.initialValues.newTag7 || '');
    const [newTag8, setNewTag8] = useState(props.initialValues.newTag8 || '');
    const [newTag9, setNewTag9] = useState(props.initialValues.newTag9 || '');
    const [newTag12, setNewTag12] = useState(props.initialValues.newTag12 || '');
    const [exactDate, setExactDate] = useState(new Date(props.initialValues.exactDate) || new Date());
    const [campaignDate, setCampaignDate] = useState(props.initialValues.campaignDate ? new Date(props.initialValues.campaignDate) : undefined);
    const [postDate, setPostDate] = useState(new Date(props.initialValues.postDate) || new Date());
    const [technology, setTechnology] = useState(props.initialValues.technology || []);
    const [malware, setMalware] = useState(props.initialValues.malware || []);
    const [relatedMalware, setRelatedMalware] = useState(props.initialValues.relatedMalware || []);
    const [TTPNumber, setTTPNumber] = useState(props.initialValues.TTPNumber || '');
    const [macroTTPNumber, setMacroTTPNumber] = useState(props.initialValues.macroTTPNumber || '');
    const [macroTTPName, setMacroTTPName] = useState(props.initialValues.macroTTPName || '');
    const [truknoNumber, setTruknoNumber] = useState(props.initialValues.truknoNumber || '');
    const [radioButtonsDisabled, setRadioButtonsDisabled] = useState(props.initialValues.radioButtonsDisabled || false);

    const [slideTitle, setSlideTitle] = useState(props.initialValues.slideTitle || '');
    const [actor, setActor] = useState('');

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        setSubmitting(true);
        e.preventDefault();
        const updates = {};
        updates.mainCategory = mainCategory;
        updates.url1 = url1;
        updates.url2 = url2;
        updates.url3 = url3;
        updates.url4 = url4;
        updates.url5 = url5;
        updates.title = title;
        updates.detailedDescription = detailedDescription;
        updates.subCategory = subCategory;
        updates.industry = industry;
        updates.image = image;
        updates.BAMImage = BAMImage;
        updates.tileTop = tileTop;
        updates.searchTags = searchTags;
        updates.mainCategoryType = mainCategoryType;
        updates.newTag1 = newTag1;
        updates.newTag2 = newTag2;
        updates.newTag3 = newTag3;
        updates.newTag4 = newTag4;
        updates.newTag5 = newTag5;
        updates.newTag6 = newTag6;
        updates.newTag7 = newTag7;
        updates.newTag8 = newTag8;
        updates.newTag9 = newTag9;
        updates.TTPNumber = TTPNumber;
        updates.macroTTPNumber = macroTTPNumber;
        updates.macroTTPName = macroTTPName;
        updates.truknoNumber = truknoNumber;
        updates.newTag12 = newTag12;
        updates.exactDate = exactDate;
        updates.campaignDate = campaignDate;
        updates.postDate = postDate;
        updates.technology = technology;
        updates.malware = malware;
        updates.relatedMalware = relatedMalware;

        props.onFormSubmit(updates, actor);
    };

    const renderSelectedSubCategory = (items) => {
        return (
            <div className="d-flex flex-wrap mx-1">
                {items.map(el => <span className="selected-item pl-2" key={el}>{el} <i className="material-icons ml-2" style={{ fontSize: '14px', marginTop: '3px', cursor: 'pointer' }} onClick={() => onRemoveSubCategoryClick(el)}>clear</i></span>)}
            </div>
        );
    };

    const renderSelectedIndustry = (items) => {
        return (
            <div className="d-flex flex-wrap mx-1">
                {items.map(el => <span className="selected-item pl-2" key={el}>{el} <i className="material-icons ml-2" style={{ fontSize: '14px', marginTop: '3px', cursor: 'pointer' }} onClick={() => onRemoveIndustryClick(el)}>clear</i></span>)}
            </div>
        );
    };

    const onSubCategoryAdd = (el) => {
        let newSubCateogry = [...subCategory, el];
        let newTileTop = newSubCateogry.join(' - ') + ' - ' + slideTitle + ' - ' + actor;
        if (!subCategory.includes(el)) {
            setSubCategory(newSubCateogry);
            setNewTag3(newSubCateogry.join(', '));
            setTileTop(newTileTop);
        }
    };

    const onIndustryAdd = (el) => {
        let newIndustry = [...industry, el];
        let newTileTop = newIndustry.join(' - ') + ' - ' + slideTitle + ' - ' + actor;
        if (!industry.includes(el)) {
            setIndustry(newIndustry);
            setNewTag2(newIndustry.join(', '));
            setTileTop(newTileTop);
        }
    };


    const onRemoveSubCategoryClick = (el) => {
        setSubCategory(subCategory.filter(item => item !== el));
    };

    const onRemoveIndustryClick = (el) => {
        setIndustry(industry.filter(item => item !== el));
    };

    const onImageUploadClick = (image) => {
        setImage(image);
    };

    const onBAMImageUploadClick = (image) => {
        setBAMImage(image);
    };

    // const onUrlChange = async (e) => {
    //     setLoading(true)
    //     setUrl1(e.target.value)
    //     const response = await CyberSecurity.post('/geturldata', { url: e.target.value },
    //         {
    //             headers: {
    //                 Authorization: `Bearer ${props.accessToken}`
    //             }
    //         })

    //     if (response.data.image) setImage(response.data.image);
    //     if (response.data.title) setTitle(response.data.title);
    //     if (response.data.description) setDetailedDescription(response.data.description);
    //     setLoading(false)
    // }

    const handleDateChange = date => {
        setExactDate(date);
        setNewTag6(getDate(date));
    };

    const handleCampaignDateChange = date => {
        if (date) setCampaignDate(date);
        else setCampaignDate(undefined);
    };

    const onActorChange = (e) => {
        let newTileTop = subCategory.join(' - ') + ' - ' + slideTitle + ' - ' + e.target.value;
        let newSearchTags = slideTitle + ' - ' + e.target.value;
        setActor(e.target.value);
        setNewTag4(e.target.value);
        setTileTop(newTileTop);
    };

    const onSlideTitleChange = (e) => {
        let newTileTop = subCategory.join(' - ') + ' - ' + e.target.value + ' - ' + actor;
        let newSearchTags = e.target.value + ' - ' + actor;
        setSlideTitle(e.target.value);
        setTileTop(newTileTop);
    };

    const onRemoveSearchTagClick = (el) => {
        setSearchTags(searchTags.filter(item => item !== el));
    };

    const onSearchTagsKeyPress = (e) => {
        e.key === 'Enter' && e.preventDefault();
        if (e.key === 'Enter') {

            let newSearchTags = [...searchTags, e.target.value];
            if (!searchTags.includes(e.target.value)) {
                setSearchTags(newSearchTags);
            }
            inputEl.current.value = '';
        }
    };

    const onKeyPreventSubmit = (e) => {
        e.key === 'Enter' && e.preventDefault();
    };

    const onRadioSelect = (category) => {
        setMainCategory(category);
        if (category === 'Stories') setMainCategoryType('CYBER STORY');
        if (category === 'Threats') setMainCategoryType('CYBER THREAT');
        if (category === 'Actors') setMainCategoryType('CYBER ACTOR');
        if (category === 'Solutions') setMainCategoryType('CYBER SOLUTION');
        if (category === 'Companies') setMainCategoryType('CYBER COMPANY');
    };

    const onTechValuesChange = (values) => {
        setTechnology(values);
        console.log(values);
    };

    const onMalwareValuesChange = (values) => {
        console.log(values);
        setMalware(values.map(el => el.newTag8));
        setRelatedMalware(values.map(el => el._id));
    };

    const onActorValuesChange = (selectedActor) => {
        setActor(selectedActor);
    };

    return (
        <div className="review-form">
            <Form.Group>
                <Form.Label as="legend" column sm={2}>
                    Main Category
                </Form.Label>
                <Form.Check
                    custom
                    inline
                    type="radio"
                    label="Stories"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios1"
                    disabled={radioButtonsDisabled}
                    defaultChecked={mainCategory === 'Stories' ? true : false}
                    onChange={() => onRadioSelect('Stories')}
                />
                <Form.Check
                    custom
                    inline
                    type="radio"
                    label="Threats"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios2"
                    disabled={radioButtonsDisabled}
                    defaultChecked={mainCategory === 'Threats' ? true : false}
                    onChange={() => onRadioSelect('Threats')}
                />
                <Form.Check
                    custom
                    inline
                    type="radio"
                    label="Actors"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios4"
                    disabled={radioButtonsDisabled}
                    defaultChecked={mainCategory === 'Actors' ? true : false}
                    onChange={() => onRadioSelect('Actors')}
                />
                <Form.Check
                    custom
                    inline
                    type="radio"
                    label="Solutions"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios5"
                    disabled={radioButtonsDisabled}
                    onChange={() => onRadioSelect('Solutions')}
                    defaultChecked={mainCategory === 'Solutions' ? true : false}
                />
                <Form.Check
                    custom
                    inline
                    type="radio"
                    label="Companies"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios6"
                    disabled={radioButtonsDisabled}
                    defaultChecked={mainCategory === 'Companies' ? true : false}
                    onChange={() => onRadioSelect('Companies')}
                />
            </Form.Group>
            <Form.Group>
                <div className="d-flex">
                    <div className="even-width pr-4">
                        <div className="d-flex">
                            <div className="d-flex even-width">
                                <p className="my-auto">Slide Title</p>
                                <Form.Control className="small-input even-width" type="text" placeholder="Slide Title" size="sm" value={slideTitle} onChange={onSlideTitleChange} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex even-width ml-4">
                                <p className="my-auto">Actor</p>
                                {/* <Form.Control className="small-input even-width" type="text" placeholder="Actor" size="sm" value={actor} onChange={onActorChange} onKeyPress={onKeyPreventSubmit} /> */}
                                <ActorSelect className='react-select-container' onActorValuesChange={onActorValuesChange} />

                            </div>
                        </div>
                        <Form.Control
                            className={`small-input even-width ${loading ? "loading" : null}`}
                            value={url1}
                            onChange={(e) => setUrl1(e.target.value)}
                            type="text"
                            placeholder="URL 1"
                            size="sm"
                        // disabled
                        />

                        <div className="d-flex">
                            <Form.Control className="small-input even-width" type="text" placeholder="URL 2" size="sm" value={url2} onChange={(e) => setUrl2(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            <Form.Control className="small-input even-width" type="text" placeholder="URL 3" size="sm" value={url3} onChange={(e) => setUrl3(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            <Form.Control className="small-input even-width" type="text" placeholder="URL 4" size="sm" value={url4} onChange={(e) => setUrl4(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            <Form.Control className="small-input even-width" type="text" placeholder="URL 5" size="sm" value={url5} onChange={(e) => setUrl5(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                        </div>

                        <Form.Control className="even-width" as="textarea" rows={5} type="text" placeholder="Title" size="sm" value={title}
                            onChange={(e) => setTitle(e.target.value)} onKeyPress={onKeyPreventSubmit} style={{ color: '#9F55A1' }} />
                        <Form.Control className="small-input even-width" type="text" placeholder="Detailed Description" size="sm" value={detailedDescription} onChange={(e) => setDetailedDescription(e.target.value)} onKeyPress={onKeyPreventSubmit} />

                        {/* 3. Dropdown to change the Sub Category */}
                        <div className="d-flex my-3">
                            <Dropdown className="ml-2">
                                <Dropdown.Toggle
                                    size="sm"
                                    variant="outline-secondary"
                                    id="dropdown-basic"
                                >
                                    Add Sub-Category
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {getSubCategoryOptions().map(el => <Dropdown.Item key={el} onClick={() => onSubCategoryAdd(el)}>{el}</Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                            {renderSelectedSubCategory(subCategory)}
                        </div>

                        {/* 4. Dropdown to change the Industry */}
                        <div className="d-flex my-3">
                            <Dropdown className="ml-2">
                                <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" size="sm">
                                    Add Industry
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {getIndustryOptions().map(el => <Dropdown.Item key={el} onClick={() => onIndustryAdd(el)}>{el}</Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                            {renderSelectedIndustry(industry)}
                        </div>

                        <TechnologySelect onTechValuesChange={onTechValuesChange} technology={technology} />
                        <MalwareSelect onMalwareValuesChange={onMalwareValuesChange} relatedMalware={relatedMalware} />
                    </div>

                    <div className="flex-column justify-content-center ml-auto">
                        {/* Single File Upload*/}
                        <div style={{ boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)' }}>
                            <p style={{ color: '#555', fontSize: '12px', textAlign: 'center' }}>Upload Image (Max 1MB)</p>
                            <img className="mx-4" src={image} alt="item" style={{ width: '150px', height: '150px', display: 'block', textAlign: 'center' }} />
                            <ImageUpload onImageUploadClick={onImageUploadClick} alertContainer="oc-alert-container1" />
                            {/* For Alert box*/}
                            <div id="oc-alert-container1"></div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="row">
                        <div className="col">
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #1</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag1" size="sm" value={newTag1} onChange={(e) => setNewTag1(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #2</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag2" size="sm" value={newTag2} onChange={(e) => setNewTag2(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #3</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag3" size="sm" value={newTag3} onChange={(e) => setNewTag3(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #4</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag4" size="sm" value={newTag4} onChange={(e) => setNewTag4(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #5</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag5" size="sm" value={newTag5} onChange={(e) => setNewTag5(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #6</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag6" size="sm" value={newTag6} onChange={(e) => setNewTag6(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #7</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag7" size="sm" value={newTag7} onChange={(e) => setNewTag7(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #8</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag8" size="sm" value={newTag8} onChange={(e) => setNewTag8(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>
                            <div className="d-flex">
                                <p className="my-auto w-25">New Tag #9</p>
                                <Form.Control className="small-input even-width w-75" type="text" placeholder="newTag9" size="sm" value={newTag9} onChange={(e) => setNewTag9(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                            </div>

                        </div>
                        <div className="col">
                            <div className="grid">
                                <div className="row">
                                    <div className="col-9">
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">Tile Top</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control className="small-input even-width" type="text" placeholder="Tile Top" size="sm" value={tileTop} onChange={(e) => setTileTop(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">Main Category Type</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control className="small-input even-width" type="text" placeholder="Main Category Type" size="sm" value={mainCategoryType} onChange={(e) => setMainCategoryType(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">Exact Date</p>
                                            </div>
                                            <div className="col-7">
                                                <DatePicker
                                                    selected={exactDate}
                                                    onChange={handleDateChange}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                // showTimeSelect
                                                // timeFormat="HH:mm"
                                                // timeIntervals={15}
                                                // timeCaption="time"
                                                // dateFormat="MMMM d, yyyy h:mm aa"
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">Campaign Date</p>
                                            </div>
                                            <div className="col-7">
                                                <DatePicker
                                                    selected={campaignDate}
                                                    onChange={handleCampaignDateChange}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                // showTimeSelect
                                                // timeFormat="HH:mm"
                                                // timeIntervals={15}
                                                // timeCaption="time"
                                                // dateFormat="MMMM d, yyyy h:mm aa"
                                                />
                                            </div>
                                        </div>
                                        {mainCategory === 'Threats' && <div className="row align-items-center mt-4">
                                            <div className="col-3">
                                                <p className="my-auto text-sm">TTP no</p>
                                            </div>
                                            <div className="col-3">
                                                <Form.Control className="small-input even-width" type="text" placeholder="TTP" size="sm" value={TTPNumber} onChange={(e) => setTTPNumber(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                            <div className="col-3">
                                                <p className="my-auto text-sm">Macro TTP.no</p>
                                            </div>
                                            <div className="col-3">
                                                <Form.Control className="small-input even-width" type="text" placeholder="Macro TTP" size="sm" value={macroTTPNumber} onChange={(e) => setMacroTTPNumber(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                            <div className="col-5">
                                                <p className="my-auto">Macro TTP Name</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control className="small-input even-width" type="text" placeholder="Macro TTP Name" size="sm" value={macroTTPName} onChange={(e) => setMacroTTPName(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                            <div className="col-5">
                                                <p className="my-auto">Trukno Number</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control className="small-input even-width" type="text" placeholder="Trukno Number" size="sm" value={truknoNumber} onChange={(e) => setTruknoNumber(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                        </div>}
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">New Tag #12</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control className="small-input even-width" type="text" placeholder="New Tag #12" size="sm" value={newTag12} onChange={(e) => setNewTag12(e.target.value)} onKeyPress={onKeyPreventSubmit} />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-5">
                                                <p className="my-auto">Search Tags</p>
                                            </div>
                                            <div className="col-7">
                                                <Form.Control ref={inputEl} className="small-input even-width" type="text" placeholder="Search Tags" size="sm" onKeyPress={onSearchTagsKeyPress} />
                                                <div className="d-flex flex-wrap mx-1">
                                                    {searchTags.map(el => <span className="selected-item pl-2" key={el}>{el} <i className="material-icons ml-2" style={{ fontSize: '14px', marginTop: '3px', cursor: 'pointer' }} onClick={() => onRemoveSearchTagClick(el)}>clear</i></span>)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(newTag5 && newTag5.toLowerCase().includes('breach')) && <div className="col-3">
                                        <div style={{ boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)' }}>
                                            <p style={{ color: '#555', fontSize: '12px', textAlign: 'center' }}>Upload Image (Max 1MB)</p>
                                            <img className="mx-4" src={BAMImage} alt="BAM Image" style={{ width: '80%', height: '80%', display: 'block', textAlign: 'center' }} />
                                            <ImageUpload onImageUploadClick={onBAMImageUploadClick} alertContainer="oc-alert-container2" />
                                            {/* For Alert box*/}
                                            <div id="oc-alert-container2"></div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="pb-4">
                    <Button className="mt-4" variant="primary" onClick={onSubmit}>
                        Submit
                        {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                    </Button>
                </div>
            </Form.Group>
        </div >
    );
};

function getDate(date) {
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var day = a.getDate();
    return (`${month} ${day}, ${year}`);
}

const mapStateToProps = (state, ownProps) => {
    return {
        accessToken: state.accessToken
    };
};

// AdminForm = connect(null, {emailLogin, setModalView})(AdminForm);

// export default connect(mapStateToProps, {emailLogin, setModalView})((reduxForm({form: 'adminEdit', validate }))(AdminForm));

export default connect(mapStateToProps, { updateItem, hideModal })(AdminForm);
